import { P2Accordion, P2Checkbox, P2TextLabel } from 'react-bootstrap-common-script'
import HdbSolicitorTNC from '../../../components/HOC/hdb-solicitor-form/hdb-solicitor-tnc'

function ReviewHdbSolicitor() {
  return (
    <div className='polymer-hdb-solicitor-form'>
      <P2Accordion defaultOpen={true} title={<P2TextLabel bold="700" label={"HDB"} />}>

        <HdbSolicitorTNC/>

        <div className='mt-3'>
          <P2Checkbox variant={"disabled"} isActive={true} description={<P2TextLabel required label={<span className='m-0'>I have read the above Terms & Conditions and agree for HDB to represent me.</span>} />} />
        </div>

        <div className='mt-3'>
          <P2Checkbox variant={"disabled"} isActive={true} description={<P2TextLabel tooltipContent={<span style={{color: "#212529", lineHeight: "1.5rem", fontSize: "1rem"}}>You would be required to engage a lawyer for the following,<div>1) Discharge of current mortgage loan</div><div>2) Obtaining fresh mortgage loan</div><div>3) Conveyancing for the ownership change (current owners)</div><div>4) Conveyancing for the ownership change (proposed owners)</div><br /><div>The change in flat ownership is a conveyancing process. As a recommendation, having the same lawyer acting for the process would expedite and reduce the liaising with multiple parties.</div></span>} hasTooltip label={<span className='m-0'>Conveyancing process is represented by the same lawyer as above.</span>} />} />
        </div>
    </P2Accordion>
    </div>
  )
}

export default ReviewHdbSolicitor